import { object, number, ref } from 'yup'

export const validationSchema = object({
  from: number()
    .required('From is a required field.')
    .positive()
    .integer('Please enter an integer.')
    .typeError('Please enter a positive whole number.'),

  to: number()
    .required('To is a required field.')
    .positive()
    .integer('Please enter an integer.')
    .typeError('Please enter a positive whole number.')
    .min(ref('from'), 'To must be greater or equal.'),
})
